import {Grid} from '@jobseeker/lotus/lib/foundations';
import {Card, Typography} from '@mui/material';
import Image from 'next/image';
import EmptyJob from '@jobseeker/lotus/lib/assets/icons/resources/emptyJob.svg';
import type {} from '@jobseeker/lotus/lib/mui.types';

const JobDetailEmpty = () => {
  return (
    <Card
      sx={{
        boxShadow: 2,
        borderRadius: 4,
        height: 'auto',
      }}
    >
      <Grid
        container
        sx={{
          px: 2,
          mt: 3,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 3,
          '@media (width:1280px)': {
            gap: 3,
          },
          '@media (width:1336px)': {
            gap: 8,
          },
          '@media (width:1440px)': {
            gap: 12,
          },
        }}
        gap={{xxs: 10, md: 6, lg: 23}}
        color="gray.dark"
      >
        <Grid
          item
          xxs={12}
          display={'flex'}
          flexWrap={'wrap'}
          sx={{flexDirection: 'column'}}
          justifyContent={'center'}
          alignItems={'center'}
          textAlign={'center'}
          mb={10}
        >
          <Image
            src={EmptyJob}
            alt={'JobDetailEmpty'}
            width={179}
            height={179}
            object-fit="cover"
          />
          <Typography
            color={'secondary.main'}
            fontSize={{xxs: 14, md: 18}}
            fontWeight="medium"
            mt={2}
          >
            {'Job has been closed or removed by the administrator.'}
          </Typography>
          <Typography
            color={'text.secondary'}
            fontSize={12}
            fontWeight="medium"
            mt={0.25}
          >
            {'We recommend checking out similar job opportunities available.'}
          </Typography>
        </Grid>
      </Grid>
    </Card>
  );
};

export default JobDetailEmpty;
